import {useState} from 'react';
import {Button, Form, Input, Tooltip} from 'antd';
import {useLocation, useNavigate} from 'react-router-dom';
import SERVICES from 'services';
import Toast from 'components/Toast';
import {Question} from 'phosphor-react';
import {ltrim} from 'components/formItems/FormGroup/FormGroup';

const ResetPassword = () => {
	const [inputErrors, setInputErrors] = useState({password: null, c_password: null});
	const [loading, setLoading] = useState(false);

	const navigate = useNavigate();
	const location = useLocation() as any;

	const urlParams = new URLSearchParams(location.search);
	const token = urlParams.get('token') || '';

	const onFinish = (data: any) => {
		SERVICES.AUTH.resetPasword(token, data)
			.then(() => {
				Toast.success('Your password has been changed!');
				setTimeout(() => {
					navigate('/login');
				}, 3000);
			})
			.catch(err => {
				let errMessage = null;
				if (typeof err.message !== 'string') {
					errMessage = err.message;
				} else {
					Toast.error(err.message);
				}
				setInputErrors(errMessage);
			})
			.finally(() => {
				setLoading(false);
			});
	};

	return (
		<div className="formContainer">
			<div className="formContainer_title">
				<span>Ստեղծել նոր գաղտնաբառ</span>
				<div id="divider" />
			</div>
			<Form className="formContainer_form" layout="vertical" onFinish={onFinish} autoComplete="off">
				<Form.Item
					name="password"
					validateStatus={inputErrors?.password ? 'error' : undefined}
					getValueFromEvent={(val: any) => ltrim(val.target.value)}
					help={inputErrors?.password}
					rules={[{required: true, message: 'Խնդրում ենք մուտքագրե՛ք ձեր գաղտնաբառը։'}]}>
					<Input.Password
						placeholder="Նոր գաղտնաբառ"
						className="formContainer_form_input"
						prefix={
							<Tooltip
								title="Գաղտնաբառը պետք է պարունակի առնվազն 6 նիշ՝
							մեծատառ, փոքրատառ, թիվ կամ նշան">
								<Question size={16} weight="thin" />
							</Tooltip>
						}
					/>
				</Form.Item>
				<Form.Item
					name="c_password"
					validateStatus={inputErrors?.password ? 'error' : undefined}
					getValueFromEvent={(val: any) => ltrim(val.target.value)}
					help={inputErrors?.password}
					rules={[
						{required: true, message: 'Խնդրում ենք կրկնեք ձեր գաղտնաբառը։'},
						({getFieldValue}) => ({
							validator(_, value) {
								if (!value || getFieldValue('password') === value) {
									return Promise.resolve();
								}
								return Promise.reject(new Error('Գաղտնաբառերը չեն համընկնում'));
							}
						})
					]}>
					<Input.Password placeholder="Կրկնեք գաղտնաբառը" className="formContainer_form_input" />
				</Form.Item>

				<Form.Item style={{textAlign: 'center'}}>
					<Button
						className="formContainer_form_button"
						type="primary"
						htmlType="submit"
						loading={loading}>
						Փոխել գաղտնբառը
					</Button>
				</Form.Item>
			</Form>
		</div>
	);
};

export default ResetPassword;
